(() => {
  const setFooterMenus = (root) => {
    const desktop = window.matchMedia('(min-width: 750px)');
    const menus = root.querySelectorAll('.cr-footer-menu');
    const update = () => menus.forEach((menu) => {
      menu.open = desktop.matches;
      menu.querySelector('summary').tabIndex = desktop.matches ? -1 : 0;
    });
    update();
    desktop.addEventListener('change', update);
  };
  document.querySelectorAll('.cr-footer').forEach(setFooterMenus);
  document.addEventListener('shopify:section:load', (event) => {
    const footer = event.target.querySelector('.cr-footer');
    if (footer) setFooterMenus(footer);
  });
})();
